import React from 'react'
import ComponentsSection from '../sections/ComponentsSection/ComponentsSection'

const Components = () => {
  return (
    <ComponentsSection />
  )
}

export default Components